import React, { useEffect, useState } from 'react';
import { Box } from '../library';
import {
    DataGrid,
    gridPageCountSelector,
    gridPageSelector,
    useGridApiContext,
    useGridSelector
} from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';

function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
        <Pagination
            color='primary'
            count={pageCount}
            page={page + 1}
            onChange={(event, value) => apiRef.current.setPage(value - 1)}
        />
    );
}

const DataGridXtrm = props => {
    const { density, ...rest } = props;

    return (
        <div style={{ height: 500, width: '100%' }}>
            <DataGrid
                {...rest}
                density={density ? density : 'compact'}
                components={{
                    Pagination: CustomPagination,
                    //LoadingOverlay: LinearProgress
                    NoRowsOverlay: () => (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%'
                            }}
                        >
                            No hay datos
                        </div>
                    )
                }}
            />
        </div>
    );
};

export default DataGridXtrm;
